// extracted by mini-css-extract-plugin
export default {"button":"NewCallTypeButton_button__NN44x"};